import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";

export const checkout = (data, branch) => {
  console.log("checkout data:", data);
  return axios.post(
    `${newApiBaseUrl}/carts/me/checkout?branch=${branch}`,
    data,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};

export const orderGet = (data) => {
  const params = new URLSearchParams({
    fromDate: data.from,
    toDate: data.to,
  });
  const branch = data.branch ?? data.stationId;
  if (branch != null && branch !== "") params.set("branch", String(branch));
  if (data.limit != null) params.set("limit", String(data.limit));
  if (data.offset != null) params.set("offset", String(data.offset));

  return axios.get(`${newApiBaseUrl}/admin/orders?${params.toString()}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};
export const orderPerCustomer = (customerId, branch) => {
  return axios.get(`${newApiBaseUrl}/orders?branch=${branch}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
    },
  });
};

export const updateOrderStatus = (orderId, status, branch) => {
  return axios.put(
    `${newApiBaseUrl}/orders/${orderId}`,
    { branch, status },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
      },
    },
  );
};
